module.exports = __webpack_public_path__ + "img/millfields_rd_b10.23e08dee.jpg";